import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/alert-score/{-$projection}/{-$field}')({
  beforeLoad: () => getTitleContextSlice('Alert Score'),
  staticData: {
    owner: CodeOwner.SWB,
  },
});
